
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import './App.css';

// Import layouts
import MainLayout from './layouts/MainLayout';

// Import route configurations
import mainRoutes from './routes/mainRoutes';
import { authRoutes } from './routes/authRoutes';
import { protectedRoutes } from './routes/protectedRoutes';

function App() {
  console.info('[App] render start');
  
  return (
    <div className="app-container min-h-screen flex flex-col">
      <Routes>
        {/* Auth routes have their own simple layout */}
        {authRoutes}
        
        {/* Protected routes (only accessible in Lovable dashboard) */}
        {protectedRoutes}
        
        {/* Main site routes */}
        {mainRoutes.map((route) => (
          <Route 
            key={route.path} 
            path={route.path} 
            element={
              <MainLayout>
                {route.element}
              </MainLayout>
            } 
          />
        ))}
      </Routes>
      
      <Toaster />
      
    </div>
  );
}

export default App;
